import './time-icon.scss';

export function TimeSvg() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path d="M8.267 14.462c-1.278 0-2.527-0.379-3.59-1.089s-1.891-1.719-2.38-2.9c-0.489-1.181-0.617-2.48-0.368-3.733s0.865-2.405 1.768-3.308c0.904-0.904 2.055-1.519 3.308-1.768s2.553-0.121 3.733 0.368c1.181 0.489 2.19 1.317 2.9 2.38s1.089 2.312 1.089 3.59c0 1.714-0.681 3.357-1.893 4.569s-2.855 1.893-4.569 1.893zM8.267 2.462c-1.095 0-2.166 0.325-3.077 0.933s-1.621 1.474-2.040 2.486c-0.419 1.012-0.529 2.126-0.315 3.2s0.741 2.061 1.516 2.836c0.775 0.775 1.761 1.302 2.836 1.516s2.188 0.104 3.2-0.315 1.877-1.129 2.486-2.040c0.609-0.911 0.933-1.982 0.933-3.077 0-1.469-0.584-2.878-1.622-3.916s-2.447-1.622-3.916-1.622z" />
      <path d="M10.385 10.769l-2.58-2.58v-4.343h0.923v3.96l2.308 2.312-0.651 0.651z" />
    </svg>
  );
}
